import { createAction, props } from '@ngrx/store';
import { IIdValuePair } from 'src/app/core/interfaces/common/common/id-value-pair.interface';
import { IMultiOptions } from 'src/app/core/interfaces/onboarding/business-profile/business-multi-options.interface';
import { CompanySearch } from 'src/app/core/models/business-profile/companySearch.model';
import { Address } from 'src/app/core/models/common/address.model';

export const BUSINESS_TYPE = '[BusinessProfile] BusinessType';
export const BUSINESS_INDUSTRY = '[BusinessProfile] BusinessIndustry';
export const BUSINESS_DESCRIPTION = '[BusinessProfile] BusinessDescription';
export const CUSTOMER_TYPES = '[BusinessProfile] CustomerTypes';
export const SUPPORT_METHODS = '[BusinessProfile] SupportMethod';
export const STATE_OF_ORG = '[BusinessProfile] StateOfOrg';
export const DBA = '[BusinessProfile] Dba';
export const COMPANY_ADDRESS = '[BusinessProfile] CompanyAddress';
export const ANNUAL_REVENUE = '[BusinessProfile] AnnualRevenue';
export const COMPANY_WEBSITE = '[BusinessProfile] CompanyWebsite';
export const YEAR_FOUNDED = '[BusinessProfile] YearFounded';
export const EMPLOYEE_COUNT = '[BusinessProfile] EmployeeCount';
export const INVOICING_METHOD = '[BusinessProfile] InvoicingMethod';
export const COMPANY_SEARCH = '[BusinessProfile] CompanySearch';
export const LEGACY_UPGRADE = '[BusinessProfile] LegacyUpgrade';
export const ALL = '[BusinessProfile] All';

export const BusinessTypeAction = createAction(
  BUSINESS_TYPE,
  props<{
    businessType: IIdValuePair;
  }>()
);
export const BusinessIndustryAction = createAction(
  BUSINESS_INDUSTRY,
  props<{
    businessIndustry: IIdValuePair;
  }>()
);
export const BusinessDescriptionAction = createAction(
  BUSINESS_DESCRIPTION,
  props<{
    businessDescription: string;
  }>()
);
export const CustomerTypesAction = createAction(
  CUSTOMER_TYPES,
  props<{
    customerTypes: IIdValuePair[];
  }>()
);
export const SupportMethodsAction = createAction(
  SUPPORT_METHODS,
  props<{
    supportMethods: IMultiOptions[];
  }>()
);
export const StateOfOrgAction = createAction(
  STATE_OF_ORG,
  props<{
    stateOfOrg: IIdValuePair;
  }>()
);
export const DbaAction = createAction(
  DBA,
  props<{
    dba: string;
  }>()
);
export const CompanyAddressAction = createAction(
  COMPANY_ADDRESS,
  props<{
    companyAddress: Address;
  }>()
);
export const AnnualRevenueAction = createAction(
  ANNUAL_REVENUE,
  props<{
    annualRevenue: IIdValuePair;
  }>()
);
export const CompanyWebsiteAction = createAction(
  COMPANY_WEBSITE,
  props<{
    companyWebsite: string;
  }>()
);
export const YearFoundedAction = createAction(
  YEAR_FOUNDED,
  props<{
    yearFounded: string;
  }>()
);
export const EmployeeCountAction = createAction(
  EMPLOYEE_COUNT,
  props<{
    employeeCount: IIdValuePair;
  }>()
);
export const InvoicingMethodAction = createAction(
  INVOICING_METHOD,
  props<{
    invoicingMethod: IIdValuePair;
  }>()
);
export const CompanySearchAction = createAction(
  COMPANY_SEARCH,
  props<{
    companySearch: CompanySearch;
  }>()
);
export const LegacyUpgradeAction = createAction(
  ALL,
  props<{
    businessIndustry: IIdValuePair;
    customerTypes: IMultiOptions[];
    stateOfOrg: IIdValuePair;
    dba: string;
    yearFounded: number;
    companyAddress: Address;
    annualRevenue: IIdValuePair;
    companyWebsite: string;
    employeeCount: IIdValuePair;
    invoicingMethod: IIdValuePair;
    supportMethods: IMultiOptions[];
  }>()
);
export const AllAction = createAction(
  ALL,
  props<{
    businessType: IIdValuePair;
    businessIndustry: IIdValuePair;
    businessDescription: string;
    customerTypes: IMultiOptions[];
    stateOfOrg: IIdValuePair;
    dba: string;
    companyAddress: Address;
    annualRevenue: IIdValuePair;
    companyWebsite: string;
    yearFounded: number;
    employeeCount: IIdValuePair;
    invoicingMethod: IIdValuePair;
    companySearch: CompanySearch;
    supportMethods: IMultiOptions[];
  }>()
);

export type All =
  | ReturnType<typeof BusinessTypeAction>
  | ReturnType<typeof BusinessIndustryAction>
  | ReturnType<typeof BusinessDescriptionAction>
  | ReturnType<typeof CustomerTypesAction>
  | ReturnType<typeof StateOfOrgAction>
  | ReturnType<typeof DbaAction>
  | ReturnType<typeof CompanyAddressAction>
  | ReturnType<typeof AnnualRevenueAction>
  | ReturnType<typeof CompanyWebsiteAction>
  | ReturnType<typeof YearFoundedAction>
  | ReturnType<typeof EmployeeCountAction>
  | ReturnType<typeof InvoicingMethodAction>
  | ReturnType<typeof SupportMethodsAction>
  | ReturnType<typeof CompanySearchAction>
  | ReturnType<typeof LegacyUpgradeAction>
  | ReturnType<typeof AllAction>;
